import {
  MatchedSearchableItem,
  SearchableItem,
  SearchableEntity,
  MatchedSearchIndexes
} from './SelectEntitiesForm.types'
import { MAIN_SEARCHABLE_ITEM_TEXT_PROPERTY_KEY } from './FuzzyResourcesFilter'

export const getTitleForResource = (entity: SearchableEntity): string => {
  switch (entity.__typename) {
    case 'CampaignModel':
      return entity.campaignName || entity.name
    case 'TopicModelAsMember':
      return entity.currentTopicVersion.title
    case 'EventModelAsStudent':
      return entity.eventTitle
    case 'RecurringEventModelAsAdmin':
      return entity.eventTitle
    case 'PathwayModelAsStudent':
      return entity.title
    case 'CertificationModelAsStudent':
    case 'GroupModelGQLBase':
    case 'WorkspaceModelAsCollaborator':
    case 'WorkspaceModelAsMember':
    case 'WorkspaceModelAsCoordinator':
      return entity.name
    default:
      return ''
  }
}

export const mapEntitiesToSearchableItem = (
  res: SearchableEntity[]
): SearchableItem[] =>
  res.map((resource) => ({
    id: resource.id,
    text: getTitleForResource(resource),
    type: resource.__typename,
    original: resource
  }))

export const findSearchTermEntryIndex =
  (search: string) =>
  (item: SearchableItem): MatchedSearchableItem => {
    const searchIndex = search ? item.text.indexOf(search) : -1 // do not need to search if search string is empty;

    return {
      item,
      score: searchIndex,
      matches: [
        {
          key: MAIN_SEARCHABLE_ITEM_TEXT_PROPERTY_KEY,
          indices:
            searchIndex >= 0 ? [[searchIndex, searchIndex + search.length]] : []
        }
      ]
    }
  }

export const plainSearch = <T = SearchableItem>(
  items: T[],
  search: string,
  searchCallback: (item: T, search: string) => number
): MatchedSearchableItem<T>[] =>
  items
    .map((item) => ({ v: item, i: searchCallback(item, search) }))
    .filter((v) => v.i >= 0)
    .sort((a, b) => a.i - b.i)
    .map((v) => convertSearchableToMatchedItem(v.v, v.i, search))

export const convertSearchableToMatchedItem = (item, score, search) => {
  return {
    item: item,
    score: score,
    matches:
      score >= 0
        ? [
            {
              key: MAIN_SEARCHABLE_ITEM_TEXT_PROPERTY_KEY,
              indices: [
                [score, score + search.length - 1]
              ] as MatchedSearchIndexes
            }
          ]
        : []
  }
}
